module.exports = __webpack_public_path__ + "img/PreventiaLogoSmall.cde10fe5.png";